import React from "react";
import NextImage from "../../common/NextImage";

const SocialPost = ({ commentaryData, isZeroTime, timeOnly }) => {
  const { min, pmin, apim, an, au, com, m_im } = commentaryData || {};

  const hasMedia = m_im && m_im !== "NULL" && m_im.trim() !== "";
  return (
    <div className="social_comm">
      <div className="social_comm_hd">
        <span className="cmntr_time">
          {isZeroTime ? (
            timeOnly
          ) : (
            <>
              {min}
              {pmin ? `+${pmin}` : ""}
              &apos;
            </>
          )}
        </span>

        <div className="comm_hd_dis">
          <div className="com_team_nam">
            <div className="flag">
              <img src={apim} width={18} height={18} alt={`${an}'s avatar`} />
            </div>
            <div className="nm_desc">
              <strong className="nam">{an}</strong>
              <span className="nam_aut">@{au}</span>
            </div>
          </div>

          <span
            className="cmntr_icon_text"
            dangerouslySetInnerHTML={{ __html: com }}
          />
        </div>

        <div className="social_ico">
          <i className="ico_twitter-x" aria-hidden="true" />
        </div>
      </div>

      {hasMedia && (
        <div className="social_comm_img">
          <NextImage src={m_im} fill={true} alt="Social post media" />
        </div>
      )}
    </div>
  );
};

export default SocialPost;
